// removed by extract-text-webpack-plugin
module.exports = {"headingLarge":"_3wvlcmJVfpkFNwvcMtguNQ_0","textLarge":"Lg9t8Jno_pLkEQJ-x3-6P_0","centered":"_1ui25BDQY5yii84g-kSA0G_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ccc9e55e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/PageNotFound.vue
// module id = Vb7x
// module chunks = 1